export default __webpack_public_path__ + "static/media/project_academia_de_lenguas_blur.cc94196f.png";